// extracted by mini-css-extract-plugin
export default {"password-find":"PasswordFind_password-find__1MGEo","buttons":"PasswordFind_buttons__NLi0j"};